module.exports = __webpack_public_path__ + "3276274dc81a8d285e432512de84d05f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Camp/podzimni-detsky-tabor-2.jpg
// module id = 1197
// module chunks = 0